var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import cxs from 'cxs/component';
import Theme from 'Theme';
import { Icon } from 'elements';
class Select extends Component {
    render() {
        const _a = this.props, { value, options, label, placeholder, underline, onChange } = _a, props = __rest(_a, ["value", "options", "label", "placeholder", "underline", "onChange"]);
        const unfolded = value ? true : false;
        return (React.createElement(Wrapper, Object.assign({}, props, { underline: underline, label: label }),
            label ? React.createElement(Label, { unfolded: unfolded }, label) : null,
            React.createElement(StyledSelect, { defaultValue: value, label: label, onChange: onChange },
                placeholder ? React.createElement("option", { value: undefined }) : null,
                options.map(option => (React.createElement("option", { key: option.name, value: option.value }, option.name)))),
            React.createElement(StyledIcon, { name: "arrow" })));
    }
}
Select.defaultProps = {
    underline: true
};
export default Select;
const height = Math.ceil(Theme.common.size.font * Theme.common.size.lineHeight) +
    Theme.common.size.font +
    1 +
    'px';
const Wrapper = cxs('div')(({ underline, label }) => (Object.assign({ position: 'relative', margin: Theme.size.space[1], 
    // margin: `auto ${Theme.size.space[1]}`,
    height: label ? height : undefined }, underline
    ? {
        borderBottom: `${Theme.size.hairline} solid ${Theme.color.hairline}`
    }
    : undefined)));
Wrapper.propTypes = {
    underline: PropTypes.bool,
    label: PropTypes.string
};
const Label = cxs('label')(({ unfolded }) => ({
    position: 'absolute',
    display: 'block',
    height: Theme.fontSize.regular,
    fontSize: unfolded ? Theme.fontSize.small : Theme.fontSize.regular,
    color: Theme.color.placeholder,
    transform: `translateY(${unfolded ? 0 : 0})`,
    // zIndex: -1,
    transition: 'all 450ms cubic-bezier(0.23, 1, 0.32, 1) 0ms'
}));
Label.propTypes = {
    unfolded: PropTypes.bool
};
const StyledSelect = cxs('select')(({ label }) => (Object.assign({ width: '100%', height: '100%', paddingRight: Theme.size.space[3] }, label ? { paddingTop: Theme.fontSize.regular, height } : null)));
StyledSelect.propTypes = {
    label: PropTypes.string
};
const StyledIcon = cxs(Icon)({
    position: 'absolute',
    right: 0,
    bottom: 0,
    transform: 'rotate(90deg)',
    padding: 0,
    zIndex: -1
});



//////////////////
// WEBPACK FOOTER
// ./src/elements/Select.tsx
// module id = 383
// module chunks = 0